import DataLoader from "@/components/DataLoader";
import { UserDatapointModelContent } from "@/components/UserDatapointModelContent";

import {
  RESEARCH_RELATED_TO_USER_DATAPOINT_QUERY,
  USER_DATAPOINTS_QUERY,
  USER_DATAPOINT_QUERY
} from "./graphql";

export default function ModelContent({ type, item, isGenesTest }) {
  if (type === "datapoints") {
    return (
      <DataLoader
        query={USER_DATAPOINT_QUERY}
        variables={{
          userDatapointId: item.id
        }}
        render={({ userDatapoint }) => (
          <UserDatapointModelContent
            userDatapoint={userDatapoint}
            isGenesTest={isGenesTest}
            relatedResearchQuery={RESEARCH_RELATED_TO_USER_DATAPOINT_QUERY}
            datapointGraphQuery={USER_DATAPOINTS_QUERY}
            datapointGraphSkip={false}
          />
        )}
      />
    );
  }
  return null;
}
